export default {
  SET_REVIEW(state, payload) {
    state.review = payload;
  },
};
